'use client';

import React, { useState } from 'react';
import NavBar from '@/components/header/NavBar';
import Why from '@/components/whySection';
import ContactForm from '@/components/ContactForm/ContactForm';
import Footer from '@/components/Footer/Footer';


const ContactForms: React.FC = () => {




  return (
  
  <>
  {/* Fixed background — stays behind everything while page scrolls */}
     <div
    className="bg-cover bg-center bg-no-repeat h-96 lg:h-[500px] relative"
    style={{ backgroundImage: `url('/hero/contact.avif')` }}
  >
   
<div className="absolute inset-0 bg-secondary/55 h-96 lg:h-[500px] " />
  <h1 className="absolute inset-0 flex items-center pt-20 lg:pt-40 justify-center text-white text-5xl lg:text-9xl font-extrabold text-center px-4 ">
   Contact
  </h1>
    
  </div>

  <NavBar />

<Why/>
<ContactForm/>
<Footer/>
</>
  );
};

export default ContactForms;
